(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pcp-fit"] && !Shopify.designMode) return;
  try {
    (function () {
    var fitRaf;
    function fit() {
      var h = document.getElementById('header-component');
      document.documentElement.classList.add('pcp-fitjs');
      if (!h) return;
      var cls = ['pcp-fit-1', 'pcp-fit-2', 'pcp-fit-3', 'pcp-fit-4'];
      function set(n) { cls.forEach(function (c, i) { h.classList.toggle(c, i < n); }); }
      var list = h.querySelector('.pcp-nav__list');
      var right = h.querySelector('.header__column--right');
      if (!list || !right || window.innerWidth < 750) { set(0); return; }
      var vw = document.documentElement.clientWidth;
      /* pravý sloupec bývá roztažený (1fr) – měříme skutečné ovládací prvky v něm */
      function rightEdges() {
        var l = Infinity, r = 0;
        right.querySelectorAll('a, button, .pcp-loc').forEach(function (el) {
          var b = el.getBoundingClientRect();
          if (b.width > 0 && b.height > 0) { l = Math.min(l, b.left); r = Math.max(r, b.right); }
        });
        return { l: l, r: r };
      }
      for (var n = 0; n < 4; n++) {
        set(n);
        var lr = list.getBoundingClientRect(), rr = rightEdges();
        if (lr.width > 0 && lr.right <= rr.l - 16 && rr.r <= vw - 4) return;
      }
      set(4);
    }
    /* PC Praha – zarovnání obsahu podle tlačítka „ASIC minery“ (22. 10. 2026) je ZRUŠENÉ (24. 10. 2026):
       celý web má jednotný rámec (assets/pcp-layout.css, --pcp-frame). navX() už nic neměří – jen vždy nastaví
       html.pcp-navx-off a smaže případné --pcp-nav-dx, aby stará pravidla (html:not(.pcp-navx-off) … v assets/pcp-pc.css
       a v sekcích) zůstala neaktivní. */
    function navX() {
      var root = document.documentElement;
      root.classList.add('pcp-navx-off');
      root.style.removeProperty('--pcp-nav-dx');
    }
    function fitAll() { fit(); navX(); }
    function queueFit() { cancelAnimationFrame(fitRaf); fitRaf = requestAnimationFrame(fitAll); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitAll);
    else fitAll();
    window.addEventListener('resize', queueFit);
    window.addEventListener('load', queueFit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueFit);
    document.addEventListener('pcp:currency', queueFit);
    document.addEventListener('shopify:section:load', queueFit);
  })();

  /* PC Praha – fotky minerů mají různě velké bílé okraje → na kartách se stroje zdály různě velké.
     Na malém náhledu (120 px) najdeme, kde je skutečný stroj, a fotku v rámečku zvětšíme a vycentrujeme
     tak, aby stroj vyplnil pole stejně (max. 1,6×). Posun je v %, takže platí při každé šířce. */
  (function () {
    var SEL = '.pcp-hp__img img, .card-gallery .product-media__image';
    var cache = {};
    function key(src) { try { var u = new URL(src, location.href); return u.pathname; } catch (e) { return src; } }
    function bbox(src, done) {
      var k = key(src);
      if (cache[k]) { if (cache[k].r) done(cache[k].r); else cache[k].q.push(done); return; }
      cache[k] = { q: [done] };
      var u; try { u = new URL(src, location.href); u.searchParams.set('width', '120'); u.searchParams.delete('height'); } catch (e) { return; }
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight; if (!w || !h) return;
          var c = document.createElement('canvas'); c.width = w; c.height = h;
          var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0);
          var d = x.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (var y = 0; y < h; y++) for (var i = 0; i < w; i++) {
            var o = (y * w + i) * 4;
            if (d[o + 3] < 16) continue;
            if (255 - d[o] < 20 && 255 - d[o + 1] < 20 && 255 - d[o + 2] < 20) continue;
            if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y;
          }
          if (x1 < 0) return;
          var r = { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h, a: w / h };
          cache[k].r = r; cache[k].q.forEach(function (f) { f(r); }); cache[k].q = [];
        } catch (e) {}
      };
      im.src = u.toString();
    }
    function apply(img) {
      if (img.dataset.pcpFill) return;
      var src = img.currentSrc || img.src; if (!src) return;
      img.dataset.pcpFill = '1';
      bbox(src, function (r) {
        var cs = getComputedStyle(img), W = img.clientWidth, H = img.clientHeight;
        var pw = W - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight), ph = H - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
        if (!W || !H || pw <= 0 || ph <= 0) { img.dataset.pcpFill = ''; return; }
        var dw = pw, dh = pw / r.a; if (dh > ph) { dh = ph; dw = ph * r.a; }
        var cw = (r.x1 - r.x0) * dw, ch = (r.y1 - r.y0) * dh;
        var s = Math.min(pw / cw, ph / ch, 1.6);
        if (!(s > 1.04)) return;
        var dx = ((r.x0 + r.x1) / 2 - 0.5) * dw, dy = ((r.y0 + r.y1) / 2 - 0.5) * dh;
        img.style.transformOrigin = '50% 50%';
        img.style.transform = 'translate(' + (-s * dx / W * 100).toFixed(2) + '%,' + (-s * dy / H * 100).toFixed(2) + '%) scale(' + s.toFixed(3) + ')';
      });
    }
    function scan(root) {
      (root || document).querySelectorAll(SEL).forEach(function (img) {
        if (img.complete && img.naturalWidth) apply(img);
        else img.addEventListener('load', function () { apply(img); }, { once: true });
      });
    }
    var t;
    function later() { clearTimeout(t); t = setTimeout(function () { scan(); }, 120); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
    else scan();
    document.addEventListener('shopify:section:load', later);
    if (window.MutationObserver) new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
  })();

  /* PC Praha – průhledná hlavička na hlavní stránce: html.pcp-hdr-down, jakmile je stránka posunutá (styly v assets/pcp-media.css).
     Posouvá se buď okno (telefon), nebo .page-wrapper (počítač v Horizonu) – sledujeme obojí. */
  (function () {
    var root = document.documentElement, raf = 0;
    function check() {
      raf = 0;
      var pw = document.querySelector('.page-wrapper');
      var y = Math.max(window.scrollY || 0, document.scrollingElement ? document.scrollingElement.scrollTop : 0, pw ? pw.scrollTop : 0);
      root.classList.toggle('pcp-hdr-down', y > 8);
    }
    function queue() { if (!raf) raf = requestAnimationFrame(check); }
    check();
    document.addEventListener('scroll', queue, { capture: true, passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pcp-locale"] && !Shopify.designMode) return;
  try {
    (function () {
    var SYM = { CZK: 'Kč', EUR: '€', USD: '$' };
    function getStored() { try { return localStorage.getItem('pcp_cur'); } catch (e) { return null; } }
    function store(c) { try { localStorage.setItem('pcp_cur', c); } catch (e) {} }
    function forget() { try { localStorage.removeItem('pcp_cur'); } catch (e) {} }
    /* měny, které přepínač nabízí (data-curs); USD jen s pcp_usd_on */
    function allowed(root) { return (root.dataset.curs || 'CZK,EUR').split(','); }

    function fmt(czk, cur, rate) {
      var v = cur === 'CZK' ? czk : czk / rate;
      var mn = v < 100 ? 2 : 0, mx = mn;
      /* malé kladné částky (výnos za jednotku, např. 0,0034 €) – 2 platné číslice, nikdy „0,00“ */
      if (v > 0 && v < 0.1) mx = Math.min(6, 1 - Math.floor(Math.log10(v)));
      var opts = { maximumFractionDigits: mx, minimumFractionDigits: mn };
      /* $ vždy anglicky ($1,234.56), ostatní měny podle jazyka stránky */
      var n = new Intl.NumberFormat(cur === 'USD' ? 'en-US' : ((window.PCP && window.PCP.nl) || 'cs-CZ'), opts).format(v);
      return cur === 'USD' ? '$' + n : n + ' ' + SYM[cur];
    }

    function apply(cur, root) {
      var rate = { CZK: 1, EUR: parseFloat(root.dataset.eur) || 0, USD: parseFloat(root.dataset.usd) || 0 };
      /* měna, ve které Shopify ukazuje ceny: stejný kurz jako ceny (window.PCP.fx ze snippets/pcp-fx.liquid) */
      var P0 = window.PCP || {};
      if (P0.presCur && P0.presCur !== 'CZK' && P0.fx > 0 && rate.hasOwnProperty(P0.presCur)) rate[P0.presCur] = P0.fx;
      var ok = allowed(root);
      if (!rate[cur] || ok.indexOf(cur) < 0) {
        var def = root.dataset.defCur;
        cur = def && rate[def] && ok.indexOf(def) >= 0 ? def : 'CZK';
      }
      window.PCP = window.PCP || {};
      window.PCP.cur = cur;
      window.PCP.rate = rate;
      window.PCP.format = function (czk) { return fmt(czk, window.PCP.cur, window.PCP.rate[window.PCP.cur]); };
      document.documentElement.setAttribute('data-pcp-cur', cur);
      document.querySelectorAll('[data-pcp-cur-sym]').forEach(function (el) { el.textContent = SYM[cur]; });
      document.querySelectorAll('.pcp-loc__c').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.cur === cur ? 'true' : 'false'); });
      document.querySelectorAll('[data-pcp-czk]').forEach(function (el) {
        var czk = parseFloat(el.getAttribute('data-pcp-czk'));
        if (!isNaN(czk)) el.textContent = fmt(czk, cur, rate[cur]);
      });
      document.dispatchEvent(new CustomEvent('pcp:currency', { detail: { currency: cur, rate: rate } }));
    }

    /* znovu přepíše [data-pcp-czk] aktuální měnou (bez události) – pro uzly, které se do stránky dostanou nebo se vrátí na text v Kč až po načtení (hydratace hlavičky, dynamické bloky) */
    function refresh() {
      var P = window.PCP;
      if (!P || !P.rate || !P.cur || !P.rate[P.cur]) return;
      document.querySelectorAll('[data-pcp-czk]').forEach(function (el) {
        var czk = parseFloat(el.getAttribute('data-pcp-czk'));
        if (isNaN(czk)) return;
        var t = fmt(czk, P.cur, P.rate[P.cur]);
        if (el.textContent !== t) el.textContent = t;
      });
    }
    var mo = null, queued = false;
    function watch() {
      if (mo || !window.MutationObserver) return;
      mo = new MutationObserver(function (list) {
        if (queued) return;
        for (var i = 0; i < list.length; i++) {
          if (list[i].type === 'characterData') {
            var pe = list[i].target.parentElement;
            if (pe && pe.closest('[data-pcp-czk]')) {
              queued = true;
              requestAnimationFrame(function () { queued = false; refresh(); });
              return;
            }
            continue;
          }
          var a = list[i].addedNodes;
          for (var j = 0; j < a.length; j++) {
            var n = a[j];
            if (n.nodeType === 1 && (n.hasAttribute('data-pcp-czk') || n.querySelector('[data-pcp-czk]'))) {
              queued = true;
              requestAnimationFrame(function () { queued = false; refresh(); });
              return;
            }
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    /* Telefon (< 750 px): přepínač patří do zásuvky menu (.menu-drawer, pod navigaci) – nativní výběr jazyka Horizonu je vypnutý.
       Na širším okně se vrátí na původní místo v hlavičce (značka = komentář pcp-loc). Posluchače zůstávají, uzel se jen přesouvá. */
    var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    function place() {
      var root = document.querySelector('[data-pcp-loc]');
      if (!root || !mqMobile || !root.parentNode) return;
      if (!root._pcpHome) { root._pcpHome = document.createComment('pcp-loc'); root.parentNode.insertBefore(root._pcpHome, root); }
      var drawer = document.querySelector('header-drawer .menu-drawer, .header__drawer .menu-drawer');
      if (mqMobile.matches && drawer) {
        var slot = drawer.querySelector('.pcp-loc-slot');
        if (!slot) { slot = document.createElement('div'); slot.className = 'pcp-loc-slot'; drawer.appendChild(slot); }
        if (root.parentNode !== slot) slot.appendChild(root);
      } else if (root._pcpHome.parentNode && root.previousSibling !== root._pcpHome) {
        root._pcpHome.parentNode.insertBefore(root, root._pcpHome.nextSibling);
      }
    }
    if (mqMobile) {
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', place);
      else if (mqMobile.addListener) mqMobile.addListener(place);
    }

    function init() {
      place();
      document.querySelectorAll('[data-pcp-loc]').forEach(function (root) {
        if (root.dataset.ready) return;
        root.dataset.ready = '1';
        var btn = root.querySelector('[data-pcp-loc-btn]');
        var panel = root.querySelector('[data-pcp-loc-panel]');
        function set(open) {
          panel.hidden = !open;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          root.toggleAttribute('data-open', open);
        }
        btn.addEventListener('click', function (e) { e.stopPropagation(); set(panel.hidden); });
        document.addEventListener('click', function (e) { if (!root.contains(e.target)) set(false); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { set(false); btn.focus(); } });
        root.querySelectorAll('.pcp-loc__opt').forEach(function (o) {
          o.addEventListener('click', function (e) {
            if (o.getAttribute('aria-disabled') === 'true' || o.classList.contains('is-current')) { e.preventDefault(); return; }
            root.querySelector('[data-pcp-loc-locale]').value = o.dataset.locale;
            root.querySelector('[data-pcp-loc-country]').value = o.dataset.country;
          });
        });
        root.querySelectorAll('.pcp-loc__c').forEach(function (b) {
          b.addEventListener('click', function () { store(b.dataset.cur); apply(b.dataset.cur, root); });
        });
        var saved = getStored();
        if (saved && allowed(root).indexOf(saved) < 0) { forget(); saved = null; }
        apply(saved || root.dataset.defCur || 'CZK', root);
      });
      watch();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    window.addEventListener('load', refresh);
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pcp-nav-js"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      document.querySelectorAll('[data-pcp-nav]').forEach(function (nav) {
        if (nav.dataset.pcpReady) return;
        nav.dataset.pcpReady = '1';
        var items = Array.prototype.filter.call(nav.querySelectorAll('[data-pcp-item]'), function (i) {
          return i.querySelector('[data-pcp-panel]');
        });
        var timer;
        function trig(i) { return i.querySelector('[data-pcp-trigger]'); }
        function close(i) {
          i.removeAttribute('data-open');
          var t = trig(i);
          if (t) t.setAttribute('aria-expanded', 'false');
        }
        function open(i) {
          items.forEach(function (x) { if (x !== i) close(x); });
          i.setAttribute('data-open', '');
          var t = trig(i);
          if (t) t.setAttribute('aria-expanded', 'true');
        }
        items.forEach(function (i) {
          i.addEventListener('pointerenter', function (e) {
            if (e.pointerType !== 'mouse') return;
            clearTimeout(timer);
            timer = setTimeout(function () { open(i); }, i.hasAttribute('data-open') ? 0 : 70);
          });
          i.addEventListener('pointerleave', function (e) {
            if (e.pointerType !== 'mouse') return;
            clearTimeout(timer);
            timer = setTimeout(function () { close(i); }, 220);
          });
          var t = trig(i);
          t.addEventListener('click', function (e) {
            if (window.matchMedia('(hover: none)').matches && !i.hasAttribute('data-open')) {
              e.preventDefault();
              open(i);
            }
          });
          t.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown' || e.key === ' ') {
              e.preventDefault();
              open(i);
              var first = i.querySelector('[data-pcp-panel] a');
              if (first) first.focus();
            }
          });
          i.addEventListener('focusout', function (e) {
            if (!i.contains(e.relatedTarget)) close(i);
          });
        });
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          items.forEach(function (i) {
            if (i.hasAttribute('data-open')) { close(i); var t = trig(i); if (t) t.focus(); }
          });
        });
        document.addEventListener('click', function (e) {
          if (!nav.contains(e.target)) items.forEach(close);
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
